import {LocationCollection} from "../collections/Locations";
import {BaseAppView, BaseAppViewOptions} from "../../_BaseAppViews";
import {ModuleCollection} from "../../../collections/Modules";
import {LocationChannelCollection} from "../collections/LocationChannels";
import {BaseModifyModalView, BaseModifyModalViewOptions} from "../../../views/modals/_BaseModifyModal";


/* The basic view for the locations app */
export interface BaseWeatherAppViewOptions extends BaseAppViewOptions {
    locationCollection: LocationCollection,
    locationId?: number
}

export class BaseWeatherAppView extends BaseAppView {

    options: BaseWeatherAppViewOptions;

    constructor(options: BaseWeatherAppViewOptions){
        super(options);
    }

}

export interface BaseWeatherModalViewOptions extends BaseLocationViewOptions, BaseModifyModalViewOptions {}

export class BaseWeatherModalView extends BaseModifyModalView {

    options: BaseWeatherModalViewOptions;

    constructor(options: BaseWeatherModalViewOptions){
        super(options);
    }

}



export interface BaseLocationViewOptions extends BaseWeatherAppViewOptions {
    locationId: number,
    locationChannelCollections: {[key: number]: LocationChannelCollection};
}

export interface WeatherNavOptions extends BaseLocationViewOptions {
    isGrouped: boolean
}

export class BaseLocationView extends BaseWeatherAppView {

    options: BaseLocationViewOptions;

    constructor(options: BaseLocationViewOptions){
        super(options);
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/weather/views/_BaseWeatherAppViews.ts